import { Injectable, OnDestroy } from '@angular/core';
import { Event, NavigationEnd, Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { SubscriptionsManager } from '../shared/util/subscriptions-manager';

@Injectable()
export class NavService implements OnDestroy {

    subscriptionManager = new SubscriptionsManager();
    public sideNav: any;
    public currentUrl = new BehaviorSubject<string>(undefined);

    constructor(private router: Router) {
        this.subscriptionManager.add = this.router.events.subscribe((event: Event) => {
            if (event instanceof NavigationEnd) {
                this.currentUrl.next(event.urlAfterRedirects);
            }
        });
    }

    ngOnDestroy(): void {
        this.subscriptionManager.unsubscribeAll();
    }

    public closeNav() {
        this.sideNav.close();
    }

    public openNav() {
        this.sideNav.open();
    }
}
